<template>
    <div class="coldContainer" :class="{'coldContainerDark' : isDark}">
        <TitleBar title="庄家态度" :type="type"></TitleBar>
        <div class="coldBox">
            <div class="coldCard left" @click="goModelList">
                <p>{{bankerLeft.home_team}}</p>
                <p>{{bankerLeft.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: bankerLeft.sclass_color}">{{bankerLeft.sclass_name}}</span>
                    <span class="time">{{matchTimeLeft}}</span>
                </div>
                <div class="result">
                    <p>
                        <ChartsPie
                            id="bankerPieLeft"
                            :colors = "['#FF5048','#eeeeee']"
                            :data="[bankerLeft.value, 100 - bankerLeft.value]"
                            type="banker"
                            :text="bankerLeft.value + '%'"
                        />
                    </p>
                    <p>{{bankerLeft.str}}</p>
                </div>
            </div>
            <div class="coldCard" @click="goModelList">
                <p>{{bankerRight.home_team}}</p>
                <p>{{bankerRight.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: bankerRight.sclass_color}">{{bankerRight.sclass_name}}</span>
                    <span class="time">{{matchTimeRight}}</span>
                </div>
                <div class="result">
                    <p>
                        <ChartsPie
                            id="bankerPieRight"
                            :colors = "['#FF5048','#eeeeee']"
                            :data="[bankerRight.value, 100 - bankerRight.value]"
                            type="banker"
                            :text="bankerRight.value + '%'"
                        />
                    </p>
                    <p>{{bankerRight.str}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from './common/titleBar.vue'
import ChartsPie from '../../components/datamodel/common/chartsPie.vue'
export default {
    name: 'bankerAttitudeCorpus',
    props: ['bankerData'],
    components: {
        TitleBar,
        ChartsPie
    },
    watch: {
        data: {
            handler () {
                this.renderBankerList();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "5",
            bankerLeft: {},
            bankerRight: {},
            matchTimeLeft: "",
            matchTimeRight: ""
        }
    },
    methods: {
        renderBankerList () {
            if (this.bankerData) {
                this.bankerLeft = this.bankerData.list[0];
                this.bankerRight = this.bankerData.list[1];
                this.matchTimeLeft = this.bankerData.list[0].match_time.substring(5, 16).replace('-', '月');
                this.matchTimeRight = this.bankerData.list[1].match_time.substring(5, 16).replace('-', '月');
            }
        },
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>
